import { Base } from './_base.model';

export class SupportContact extends Base {
  id: number;
  bureaus: any[];
  support_label: string;
  support_program_phone: string;
  support_program_email: string;
  support_travel_phone: string;
  support_travel_email: string;
  support_after_hours: string;
  is_default: boolean;
  created_at: Date;

  deserialize(obj: any) {
    obj.bureaus = obj.support_contact_bureaus.map(c => c.bureau_id);
    delete obj.support_contact_bureaus;
    Object.assign(this, obj);
    return this;
  }
}
